import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  requesting: false,
  error: null,
  response: null,
};

const payment = createReducer(initialState, {
  // cancel
  [actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_REQUEST](state) {
    return { ...state, requesting: true, error: null, response: null };
  },
  [actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.PAYMENT_CANCEL_SUBSCRIPTION_SUCCESS](state, { payload }) {
    return { ...state, error: null, requesting: false, response: payload };
  },
  // buy
  [actionTypes.PAYMENT_BUY_SUBSCRIPTION_REQUEST](state) {
    return { ...state, requesting: true, error: null, response: null };
  },
  [actionTypes.PAYMENT_BUY_SUBSCRIPTION_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.PAYMENT_BUY_SUBSCRIPTION_SUCCESS](state, { payload }) {
    return { ...state, error: null, requesting: false, response: payload };
  },
  // reset
  [actionTypes.PAYMENT_RESET_STATE](state) {
    return { ...state, error: null, requesting: false, response: null };
  },
});

export default payment;

export const getIsRequesting = (state) => state.payment.requesting;
export const getError = (state) => state.payment.error;
export const getResponse = (state) => state.payment.response;
